import type { BasketSummarySubjectType } from '@api/api/basket-summary';
import type { InsightFilter } from '@api/api/insights';
import { useMemo } from 'react';
import { buildSentimentBreakdown } from '../utils/buildSentimentBreakdown';
import { useThemeMentions } from './useThemeMentions';

export const usePulseSentimentBreakdown = ({
  id,
  subjectType = 'theme',
  scenarioInsights,
}: {
  id: string;
  subjectType?: BasketSummarySubjectType;
  scenarioInsights?: InsightFilter[];
}) => {
  const { data, isLoading, isError } = useThemeMentions({ id, subjectType });

  return {
    data: useMemo(
      () =>
        data || scenarioInsights
          ? buildSentimentBreakdown(data?.mentions ?? [], scenarioInsights)
          : undefined,
      [data, scenarioInsights]
    ),
    isLoading,
    isError,
  };
};
